import React, { useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled, css } from "twin.macro";
import { Divider, Dropdown, Image, Modal, Tag, Menu, Popconfirm } from "antd";
import {
	AddNewTag,
	CustomRadio,
	EditPlan,
	EmptyData,
	NewPlans,
	PageLoading,
	SplitPane,
} from "../../components";
import MainLayout from "../../components/MainLayout/MainLayout";
import timeFilled from "../../assets/svg/TimePink.svg";
import flag from "../../assets/svg/flag_fill.svg";

import { hideScrollbar, LandingTitle } from "../../lib/styles/styleLibrary";
import Auth from "../../lib/middleware/auth";
import { useMutation, useQuery } from "react-query";
import {
	addPlan,
	deletePlan,
	fetchPlans,
	fetchPlanTags,
	updatePlanProgress,
} from "../../redux/actions/plans";
import { isEmpty, Toast, truncate } from "../../lib/helpers/helpers";
import dayjs from "dayjs";
import { EditOutlined, ReadOutlined, UngroupOutlined } from "@ant-design/icons";
import del from "../../assets/svg/del.png";
import { useMediaQuery } from "react-responsive";
import { v4 } from "uuid";

const Wrapper = styled.div`
	${tw`p-4 md:(pl-12 pr-12 pt-10) pb-0 h-full w-full`}

	.hide-scrollbar {
		-ms-overflow-style: none !important; /* IE and Edge */
		scrollbar-width: none !important;
		&::-webkit-scrollbar {
			display: none !important;
		}
	}
`;

const PlanCard = styled.div`
	${tw`w-full bg-white h-56 sm:h-52 p-4 mt-4 mb-4`}
	${({ bg }) => bg && `background: ${bg};`};
	${({ hasShadow }) =>
		hasShadow && `box-shadow: 0px 9px 30px rgba(32, 56, 85, 0.1);`};
	border-radius: 10px;

	ul {
		.ant-dropdown-menu {
			${tw`rounded-lg!`}/* border-radius: 10px !important; */
		}
	}
`;
const floatBtn = (props) => css`
	${tw`absolute font-bold bg-appPink flex items-center justify-center rounded-full border-none text-white h-12 w-12 hover:(shadow-lg cursor-pointer)`}
	bottom: 1.5rem;
	right: 1.5rem;
	font-size: 2rem;
	box-shadow: 0px 10px 35px rgba(241, 94, 95, 0.25);
`;

const Connector = styled.div`
	${tw`w-8 ml-5`}
	border: 1px solid rgba(193, 202, 207, 0.5);
	transform: rotate(90deg);
`;

const MyPlan = (props) => {
	const isMobile = useMediaQuery({ maxWidth: 1217 });
	const experience = Auth.getExperience();
	const couple = Auth.getCouple();
	const [addTagModal, setAddTagModal] = useState(false);
	const [newPlanModal, setNewPlanModal] = useState("");
	const [filter, setFilter] = useState("all");
	const [tag, setTag] = useState("");
	const {
		data: tagData,
		isLoading: isTagLoading,
		refetch,
	} = useQuery("tags", fetchPlanTags, {
		refetchOnWindowFocus: false,
	});
	const {
		data: plansData,
		isLoading: loadingPlans,
		refetch: refectchPlans,
	} = useQuery(
		["Plans", { filter, tag }],
		() => fetchPlans({ filter, tag }),
		{
			// notifyOnChangeProps: [filter],
			refetchOnWindowFocus: false,
		}
	);

	const tags = tagData?.data;
	const plans = plansData?.data;

	const handleFilter = (e) => {
		setFilter(e.target.value);
	};
	const { mutateAsync: createPlan, isLoading: createLoad } =
		useMutation(addPlan);

	const { mutateAsync: updateProgress } = useMutation(updatePlanProgress);
	const { mutateAsync: delPlan, isLoading: delLoading } =
		useMutation(deletePlan);
	const [selectedPlan, setSelectedPlan] = useState({});

	const MainSection = () => {
		const [expand, setExpand] = useState(false);
		const [editVisible, setEditVisible] = useState(false);
		const handleDelete = async () => {
			try {
				const response = await delPlan(selectedPlan.id);
				console.log(response.data);
				const { hasError } = response.data;
				if (hasError) {
					return;
				} else {
					Toast.fire({
						icon: "success",
						title: `${response.data}`,
					});
					setTimeout(() => {
						refectchPlans();
					}, 500);
				}
			} catch (err) {}
		};

		const menu = (
			<Menu>
				<Menu.Item key="readMenu">
					<ReadOutlined onClick={() => setExpand(true)} />
				</Menu.Item>
				<Menu.Item key="editMenu">
					{" "}
					<EditOutlined onClick={() => setEditVisible(true)} />
				</Menu.Item>
				<Menu.Item key="deleteMenu">
					<Popconfirm
						placement="top"
						title={"Are you sure to delete this Plan/Task?"}
						onConfirm={handleDelete}
						okText="Yes"
						cancelText="No">
						<Image
							preview={false}
							src={del}
							alt=""
							width={12}
							height={12}
						/>
					</Popconfirm>
				</Menu.Item>
			</Menu>
		);
		return (
			<div tw="h-full w-full overflow-y-scroll mb-10" css={hideScrollbar}>
				<div tw="w-full">
					{isEmpty(plans) ? (
						<EmptyData />
					) : (
						plans?.map((p, i) => {
							return (
								<div
									key={i}
									onClick={() => setSelectedPlan(p)}
									style={{
										opacity:
											selectedPlan.id === p.id &&
											delLoading
												? "0.5"
												: "1",
									}}>
									<PlanCard
										bg={
											p?.progress === "ongoing"
												? "#FFF1EF"
												: p?.progress === "pending"
												? "#fff"
												: p?.progress === "done"
												? "#00ffb070"
												: ""
										}
										hasShadow={
											p?.progress !== "done" && true
										}>
										<div tw="flex flex-nowrap items-center justify-around w-full! flex-auto gap-2">
											<div
												tw="flex flex-nowrap items-center w-8/12 md:w-full overflow-x-scroll"
												css={hideScrollbar}>
												{p?.set_tags?.map((t, i) => {
													const randomColor =
														Math.floor(
															Math.random() *
																16777215
														).toString(16);

													return (
														<span key={v4()}>
															<Tag
																color={`#${randomColor}`}
																tw="rounded-2xl px-4 py-1 font-medium text-xs"
																style={{
																	color: "#ffffff",
																}}>
																{
																	t.plan_tag
																		.name
																}
															</Tag>
														</span>
													);
												})}
											</div>

											<span tw="flex flex-nowrap items-center w-4/12 justify-end gap-3">
												{p?.progress === "done" ? (
													<Image
														preview={false}
														src={flag}
														alt=""
														width={15}
														height={15}
													/>
												) : (
													<Image
														preview={false}
														src={timeFilled}
														alt=""
														width={15}
														height={15}
													/>
												)}
												<span tw="opacity-50 text-xs md:text-sm font-semibold">
													{dayjs(p?.createdAt).format(
														"ddd, MMM DD"
													)}
												</span>
											</span>
										</div>
										<h4 tw="mt-4 text-xs md:text-sm font-bold">
											{truncate(p?.title, 45)}
										</h4>
										<p tw="opacity-70 text-xs md:text-sm h-12 whitespace-pre-wrap">
											{truncate(p?.description, 80)}
										</p>

										<Divider tw="mt-4 mb-4" />
										<div tw="flex flex-row flex-wrap md:flex-nowrap gap-2 justify-between items-center">
											<CustomRadio
												planId={p.id}
												refetch={refectchPlans}
												updateProgress={updateProgress}
												defaultValue={p?.progress}
											/>
											<Dropdown
												trigger="click"
												overlay={menu}
												placement="topCenter"
												arrow>
												<UngroupOutlined tw="text-lg text-appTextFaded" />
											</Dropdown>
										</div>
									</PlanCard>
									{plans[i + 1] ? <Connector /> : ""}
								</div>
							);
						})
					)}
				</div>
				<Modal
					footer=""
					visible={expand}
					centered
					width={isMobile ? "100%" : "75%"}
					onCancel={() => setExpand(false)}
					maskClosable={false}>
					<PlanCard tw="h-full overflow-y-scroll p-0!">
						<div tw="flex flex-nowrap items-center justify-between w-full!">
							<div
								tw="flex flex-nowrap items-center overflow-x-scroll"
								css={hideScrollbar}>
								{selectedPlan.set_tags?.map((t, i) => {
									const randomColor = Math.floor(
										Math.random() * 16777215
									).toString(16);

									return (
										<Tag
											key={v4()}
											color={`#${randomColor}`}
											tw="rounded-2xl px-4 py-1 font-medium"
											style={{
												color: "#ffffff",
												fontSize: "0.65rem",
											}}>
											{t.plan_tag.name}
										</Tag>
									);
								})}
							</div>

							<span tw="flex flex-nowrap items-center w-full justify-end gap-2">
								{selectedPlan?.progress === "done" ? (
									<Image
										preview={false}
										src={flag}
										alt=""
										width={15}
										height={15}
									/>
								) : (
									<Image
										preview={false}
										src={timeFilled}
										alt=""
										width={15}
										height={15}
									/>
								)}

								<span tw="opacity-50 text-xs md:text-sm font-semibold">
									{dayjs(selectedPlan?.createdAt).format(
										"ddd, MMM DD"
									)}
								</span>
							</span>
						</div>
						<h4 tw="mt-4 text-base mb-6 font-bold">
							{selectedPlan?.title}
						</h4>
						<p tw="opacity-70 text-xs md:text-sm  h-full whitespace-pre-wrap">
							{selectedPlan?.description}
						</p>
						<Divider />

						<h4 tw="font-bold text-appPink text-right text-xs md:text-sm  uppercase m-0 p-0">
							{" "}
							Status:{" "}
							<span tw="text-appTextFaded font-semibold">
								{" "}
								{selectedPlan?.progress}{" "}
							</span>
						</h4>
					</PlanCard>
				</Modal>
				<Modal
					footer=""
					visible={editVisible}
					centered
					onCancel={() => setEditVisible(false)}
					maskClosable={false}>
					<EditPlan
						plan={selectedPlan}
						setAddTagModal={setAddTagModal}
						experience={experience}
						tags={tags}
						refetch={refectchPlans}
						setEditVisible={setEditVisible}
						createPlan={createPlan}
						isTagLoading={isTagLoading}
						couple={couple}
					/>
				</Modal>
			</div>
		);
	};

	return (
		<MainLayout>
			{(createLoad || loadingPlans) && <PageLoading />}
			<Wrapper css={hideScrollbar}>
				<div tw="flex flex-row justify-between items-center gap-4 mb-4">
					<LandingTitle tw="text-2xl font-bold leading-8 m-0! whitespace-pre">
						My Plan
					</LandingTitle>
					<div tw="flex flex-row items-center justify-end gap-1">
						<select
							tw="bg-appPlaceholder mr-1 rounded-md px-1 py-1 text-xs md:text-sm text-white font-semibold"
							value={filter}
							onChange={handleFilter}>
							<option value="all">All</option>
							<option value="pending">Pending</option>
							<option value="ongoing">Ongoing</option>
							<option value="done">Done</option>
						</select>

						<select
							tw="bg-appPinkSaturated rounded-md px-1 py-1 text-xs md:text-sm text-white font-semibold"
							value={tag}
							onChange={(e) => setTag(e.target.value)}>
							<option value="">Filter Tag</option>
							{tags?.map((t, i) => {
								return (
									<option value={t.name} key={i}>
										{t.name}
									</option>
								);
							})}
						</select>
					</div>
				</div>

				<div
					tw="w-full overflow-y-scroll"
					css={hideScrollbar}
					style={{ height: isMobile ? "32rem" : "auto" }}>
					<SplitPane
						wrapDirection={"column"}
						hideRightSide={isMobile ? true : false}
						left={<MainSection />}
						right={
							<NewPlans
								experience={experience}
								tags={tags}
								createPlan={createPlan}
								isTagLoading={isTagLoading}
								setAddTagModal={setAddTagModal}
								couple={couple}
								refetch={refectchPlans}
							/>
						}
					/>
				</div>

				{isMobile && (
					<button
						css={floatBtn}
						onClick={() => setNewPlanModal(true)}>
						+
					</button>
				)}
			</Wrapper>
			<Modal
				footer=""
				visible={addTagModal}
				centered
				onCancel={() => setAddTagModal(false)}
				maskClosable={false}>
				<AddNewTag
					id={couple?.id}
					handleCancel={() => setAddTagModal(false)}
					refetch={() => refetch()}
				/>
			</Modal>
			<Modal
				footer=""
				visible={newPlanModal}
				centered
				onCancel={() => setNewPlanModal(false)}
				maskClosable={false}>
				<NewPlans
					experience={experience}
					tags={tags}
					createPlan={createPlan}
					isTagLoading={isTagLoading}
					setAddTagModal={setAddTagModal}
					couple={couple}
					refetch={refectchPlans}
				/>
			</Modal>
		</MainLayout>
	);
};

export default MyPlan;
